import bezier from 'bezier-easing';
import { addJqPlugin, transitionCss } from "./helper";
addJqPlugin('transitionCss', transitionCss);

const PRELOAD_DURATION = 15000;

export default function Preloader() {
    let startFinish = false; // начали завершать прогрессбар вручную после загрузки страницы
    let progressDistance;
    let progressStepRaf;
    let $preloader = $('[data-preloader]');
    let $preloaderProgress = $('[data-preloader-progress]');

    this.$el = $preloader;

    /**
     * начать анимацию прогрессбара (начало загрузки страницы)
     */
    this.start = function () {

        let easingOut = bezier(0.1, 0.4, 0, 1);
        let startTime = Date.now();
        progressStep();

        function progressStep() {
            let deltaTime = (Date.now() - startTime) / PRELOAD_DURATION;
            if (deltaTime >= 1) {
                progressDistance = 1;
            } else {
                progressDistance = easingOut(deltaTime);
            }

            $preloaderProgress.css({width: progressDistance * 100 + '%'});
            if (progressDistance !== 1 && !startFinish) {
                progressStepRaf = window.requestAnimationFrame(progressStep);
            }
        }
    };

    /**
     * закончить анимацию прогрессбара (страница загрузилась)
     * @return {Promise} резолвится, когда прогресс дошел до 100% (можно скрывать прелоадер)
     */
    this.finish = function () {
        startFinish = true;
        window.cancelAnimationFrame(progressStepRaf);
        return new Promise(function (resolve) {
            if (progressDistance === 1) {
                resolve();
            } else {
                let remainTime = Math.round((1 - progressDistance) * 1000);
                $preloaderProgress.css({width: '100%', transition: `ease-in ${remainTime}ms`});
                setTimeout(resolve, remainTime);
            }
        });
    };

    /**
     * скрыть прелоадер
     * @return {Promise}
     */
    this.hide = function () {
        let hidePromise = $preloader.transitionCss(() => {
            $preloader.addClass('preloader--fade-out');
        });
        hidePromise.then(() => {
            $preloader.addClass('uk-hidden');
        });
        return hidePromise;
    };
};


// WEBPACK FOOTER //
// ./scripts/preloader.js